import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth, RequireStaff } from "./auth/RouteGuards";
import LoginPage from "./pages/LoginPage";
import StaffLoginPage from "./pages/StaffLoginPage";
import { CustomerCallbackPage, StaffCallbackPage } from "./pages/CallbackPage";
import RoleBasedDashboard from "./pages/RoleBasedDashboard";
import BuildingsPage from "./pages/BuildingsPage";
import BuildingDetailPage from "./pages/BuildingDetailPage";
import BuildingDashboardPage from "./pages/BuildingDashboardPage";
import UnitDashboardPage from "./pages/UnitDashboardPage";
import ReadingsPage from "./pages/ReadingsPage";
import AlertsPage from "./pages/AlertsPage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import InvoicesPage from "./pages/InvoicesPage";
import AuditLogPage from "./pages/AuditLogPage";
import StaffAlertsPage from "./pages/StaffAlertsPage";
import StaffBuildingsPage from "./pages/StaffBuildingsPage";
import StaffDashboardPage from "./pages/StaffDashboardPage";
import StaffMetersPage from "./pages/StaffMetersPage";
import StaffOrganisationsPage from "./pages/StaffOrganisationsPage";
import StaffOrgDetailPage from "./pages/StaffOrgDetailPage";
import StaffUsersPage from "./pages/StaffUsersPage";
import SystemAuditLogPage from "./pages/SystemAuditLogPage";
import UnitDetailPage from "./pages/UnitDetailPage";
import WelcomePage from "./pages/WelcomePage";

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/staff/login" element={<StaffLoginPage />} />
      <Route path="/auth/callback" element={<CustomerCallbackPage />} />
      <Route path="/staff/callback" element={<StaffCallbackPage />} />
      <Route path="/welcome" element={<WelcomePage />} />

      {/* Customer / Org */}
      <Route path="/dashboard" element={<RequireAuth><RoleBasedDashboard /></RequireAuth>} />
      <Route path="/buildings" element={<RequireAuth><BuildingsPage /></RequireAuth>} />
      <Route path="/buildings/:buildingId" element={<RequireAuth><BuildingDetailPage /></RequireAuth>} />
      <Route path="/buildings/:buildingId/dashboard" element={<RequireAuth><BuildingDashboardPage /></RequireAuth>} />
      <Route path="/buildings/:buildingId/units/:unitId" element={<RequireAuth><UnitDetailPage /></RequireAuth>} />
      <Route path="/units/:unitId" element={<RequireAuth><UnitDashboardPage /></RequireAuth>} />
      <Route path="/readings" element={<RequireAuth><ReadingsPage /></RequireAuth>} />
      <Route path="/alerts" element={<RequireAuth><AlertsPage /></RequireAuth>} />
      <Route path="/users" element={<RequireAuth><UsersPage /></RequireAuth>} />
      <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
      <Route path="/invoices" element={<RequireAuth><InvoicesPage /></RequireAuth>} />
      <Route path="/audit" element={<RequireAuth><AuditLogPage /></RequireAuth>} />

      {/* Staff — platform admin */}
      <Route path="/staff" element={<RequireAuth><RequireStaff><StaffDashboardPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations" element={<RequireAuth><RequireStaff><StaffOrganisationsPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/buildings" element={<RequireAuth><RequireStaff><StaffBuildingsPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/users" element={<RequireAuth><RequireStaff><StaffUsersPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/meters" element={<RequireAuth><RequireStaff><StaffMetersPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/alerts" element={<RequireAuth><RequireStaff><StaffAlertsPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/audit" element={<RequireAuth><RequireStaff><SystemAuditLogPage /></RequireStaff></RequireAuth>} />

      {/* Staff — drilled into a specific org. Pages reuse the customer-facing components
          via the useOrgId() hook which reads the :orgId URL parameter. */}
      <Route path="/staff/organisations/:orgId" element={<RequireAuth><RequireStaff><StaffOrgDetailPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/buildings" element={<RequireAuth><RequireStaff><BuildingsPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/buildings/:buildingId" element={<RequireAuth><RequireStaff><BuildingDetailPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/buildings/:buildingId/dashboard" element={<RequireAuth><RequireStaff><BuildingDashboardPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/buildings/:buildingId/units/:unitId" element={<RequireAuth><RequireStaff><UnitDetailPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/readings" element={<RequireAuth><RequireStaff><ReadingsPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/alerts" element={<RequireAuth><RequireStaff><AlertsPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/users" element={<RequireAuth><RequireStaff><UsersPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/invoices" element={<RequireAuth><RequireStaff><InvoicesPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/audit" element={<RequireAuth><RequireStaff><AuditLogPage /></RequireStaff></RequireAuth>} />
      <Route path="/staff/organisations/:orgId/settings" element={<RequireAuth><RequireStaff><SettingsPage /></RequireStaff></RequireAuth>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
